import React, {useEffect, useMemo, useState} from 'react';
import FiltersHandler from "../../../components/FiltersHandler";
import {sortAlphabetically} from "@arboxappv4/shared/src/helpers/functions";
import {getFiltersConfig} from "@arboxappv4/shared/src/helpers/filters";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {FlexRowSection} from "../../../styles/globalStyles";
import useScreenSize from "../../../helpers/hooks/useScreenSize";
import styled from "styled-components";
import {isRTL} from "../../../helpers/i18n";

const TracksHeader = (props) => {
    const { tracks, onFiltered, selectedLocation } = props;
    const box = useSelector(state => state.site.box)
    const [filtersConfig, setFiltersConfig] = useState(null);
    const {isMobile} = useScreenSize()

    const departments = useMemo(() => {
        if (tracks && box?.departments !== 0) {
            const optionsObj = tracks.reduce((acc, track) => {
                (track.membership_types ?? []).forEach(mt => {
                    if (mt.departments) {
                        acc[`dept-${mt.departments.id}`] = mt.departments;
                    }
                });
                return acc;
            }, {});
            return sortAlphabetically(Object.values(optionsObj), 'name')
        }
        return []
    }, [tracks, box?.departments]);

    const boxCategories = useMemo(() => {
        if (tracks) {
            const optionsObj = tracks.reduce((acc, track) => {
                (track.series_track_relations ?? []).forEach(relation => {
                    const series = relation?.series
                    if (series?.box_categories) {
                        acc[`type-${series.box_category_fk}`] = series.box_categories
                    }
                })
                return acc
            }, {})
            return sortAlphabetically(Object.values(optionsObj), 'name')
        }
        return []
    }, [tracks])

    const sessionPerWeek = useMemo(() => {
        if (tracks) {
            const valuesObj = tracks.reduce((acc, track) => {
                if (track.session_per_week != null) {
                    acc[track.session_per_week] = track.session_per_week
                }
                return acc
            }, {})
            return Object.values(valuesObj).sort((a, b) => a - b).map(value => ({
                label: t('frequency-track-label', {frequency: value}),
                value,
            }))
        }
        return []
    }, [tracks])

    useEffect(() => {
        if (box && selectedLocation && tracks !== null) {
            initFiltersConfig()
        }
    }, [box, selectedLocation, tracks, departments, boxCategories, sessionPerWeek]);

    const initFiltersConfig = () => {
        const baseConfig = getFiltersConfig({
            locations: {
                rest: {
                    filterFunc: (obj, selected) => selected === 'all' ? true : (obj.locations_box_id === selected),
                },
            },
            departments,
            boxCategories,
            sessionPerWeek,
        }, selectedLocation, t)

        const config = {...baseConfig}
        if (config.boxCategories) {
            config.trackBoxCategories = {
                ...config.boxCategories,
                label: t('filter-type-boxCategories'),
                filterFunc: (track, selected) => selected.some(categoryId =>
                    (track.series_track_relations ?? []).some(relation =>
                        relation?.series?.box_category_fk == categoryId
                    )
                ),
            }
            delete config.boxCategories
        }

        setFiltersConfig(config)
    }

    return (
        <>
            {filtersConfig && Object.keys(filtersConfig).length > 0 &&
                (isMobile ?
                    <MobileAbsoluteFilter rtl={isRTL()}>
                        <FiltersHandler unfilteredData={tracks} onFiltered={onFiltered} initConfig={filtersConfig} pageName={'track'}/>
                    </MobileAbsoluteFilter>
                    :
                    <FlexRowSection flex={'unset'}>
                        <FiltersHandler unfilteredData={tracks} onFiltered={onFiltered} initConfig={filtersConfig} pageName={'track'}/>
                    </FlexRowSection>
                )
            }
        </>
    );
};

export default TracksHeader;

const MobileAbsoluteFilter = styled.div`
    position: absolute;
    top: 25px;
    right: ${({rtl}) => rtl ? 'unset' : '20px'};
    left: ${({rtl}) => rtl ? '20px' : 'unset'};
`;
